define("ember-cp-validations/-private/internal-result-object", ["exports", "@ember/object", "@ember/object/computed", "@ember/utils", "@ember/array", "ember-cp-validations/validations/error", "ember-cp-validations/utils/utils"], function (_exports, _object, _computed, _utils, _array, _error, _utils2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = _object.default.extend({
    model: null,
    isValid: true,
    isValidating: false,
    message: null,
    warningMessage: null,
    attribute: '',
    _promise: null,
    _validator: null,
    _type: (0, _computed.readOnly)('_validator._type'),
    init() {
      this._super(...arguments);
      if (this.isAsync) {
        this._handlePromise();
      }
    },
    isWarning: (0, _computed.readOnly)('_validator.isWarning'),
    isInvalid: (0, _computed.not)('isValid'),
    isNotValidating: (0, _computed.not)('isValidating'),
    isTruelyValid: (0, _computed.and)('isNotValidating', 'isValid'),
    isTruelyInvalid: (0, _computed.and)('isNotValidating', 'isInvalid'),
    isAsync: (0, _object.computed)('_promise', function () {
      return (0, _utils2.isPromise)(this._promise);
    }),
    messages: (0, _object.computed)('message', function () {
      return (0, _array.makeArray)(this.message);
    }),
    error: (0, _object.computed)('_type', 'attribute', 'isInvalid', 'message', 'type', function () {
      if (this.isInvalid) {
        return _error.default.create({
          type: this._type,
          message: this.message,
          attribute: this.attribute
        });
      }
      return null;
    }),
    errors: (0, _object.computed)('error', function () {
      return (0, _array.makeArray)(this.error);
    }),
    warningMessages: (0, _object.computed)('warningMessage', function () {
      return (0, _array.makeArray)(this.warningMessage);
    }),
    warning: (0, _object.computed)('_type', 'attribute', 'isWarning', 'type', 'warningMessage', function () {
      if (this.isWarning && !(0, _utils.isNone)(this.warningMessage)) {
        return _error.default.create({
          type: this._type,
          message: this.warningMessage,
          attribute: this.attribute
        });
      }
      return null;
    }),
    warnings: (0, _object.computed)('warning', function () {
      return (0, _array.makeArray)(this.warning);
    }),
    _handlePromise() {
      (0, _object.set)(this, 'isValidating', true);
      this._promise.finally(() => {
        (0, _object.set)(this, 'isValidating', false);
      });
    }
  });
});